import React from "react";
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {
    action_catalog_list,
    apiURL,
    contractId,
    CORSSupport,
    userID,
    userLogin,
    userPassword
} from "../configurationConstant";
import CatalogItem from "../Components/CatalogItem";
import {Link, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {searchHeader, setSearchItem, setSearchPosition, setUser} from "../store/actions/user_actions";
import {setVisiblePosition} from "../store/actions/catalog_actions";

const search_icon = require("../images/ICON.png");

export const  Checkboxes = (checked) => {
    return(
        <Checkbox
            className={'checkbox'}
            style={{ width: 20, height: 20, padding: 0, color: '#00B63A' }}
            checked={checked}
            icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 20 }} />}
            checkedIcon={<CheckBoxIcon style={{ fontSize: 20 }} />}
        />
    )
};

class CatalogPage extends React.Component{
    constructor(props){
        super(props);
        this.getCatalog = this.getCatalog.bind(this);
        this.setPositions = this.setPositions.bind(this);
        this.filterPositions = this.filterPositions.bind(this);
        this.setCountOfPositions = this.setCountOfPositions.bind(this);
        this.searchItems = this.searchItems.bind(this);
        this.onKeyPressHandler = this.onKeyPressHandler.bind(this);
        this.state ={
            visible_position: [],
            catalog:[],
            filteredList: [],
            loaded_catalog: false,
            page: this.props.match.params.id,
            page_positions: 25,
            searched: false,
            search_name: this.props.user.search_items === '' ? '' :this.props.user.search_items
        };
    }

    componentDidMount() {
        this.getCatalog()
    }

    filterPositions = (event) => {
        this.setState({search_name: event.target.value});
        this.props.setSearchItem(event.target.value)
    };

    getCatalog(){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch(  apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_catalog_list + '&contract=' + contractId + '&log='+userLogin+'&pwd='+userPassword+'&user=' + userID,
            mode: 'cors',
        }).then(r => {
            if (r.status === 200)
                return r.json().then((data) => {
                    let filteredList = data['catalog'];
                    if(this.props.user.search_position !== '' && this.props.user.search_position !== null && this.props.user.search_position !== undefined )
                        filteredList = filteredList.filter((item) => {
                            return String(item.name).toLowerCase().includes(String(this.props.user.search_position).toLowerCase())
                        });
                    this.setState({
                        catalog: data['catalog'],
                        loaded_catalog: true,
                        filteredList: filteredList
                    });
                    this.setPositions(Number(this.props.match.params.id), this.state.page_positions)
                })
        }).catch(r => console.log(r));
    }

    setCountOfPositions(plus){
        let count = this.state.page_positions;
        switch (this.state.page_positions) {
            case 25:
                if (plus)
                    count = 50;
                break;
            case 50:
                if (plus)
                    count = 100;
                else
                    count = 25;
                break;
            case 100:
                if (!plus)
                    count = 50
                break;
        }
        this.setState({page_positions: count});
        this.setPositions(Number(this.props.match.params.id), count)
    }

    onKeyPressHandler(event) {
        if (event.keyCode === 13) {
            if(this.props.user.search_position !== '' || this.props.user.search_items !== '') {
                this.searchItems()
            }
        }
    }

    setPositions(page, count){
        if (this.state.loaded_catalog) {
            let array = this.state.filteredList.slice((page-1) * count , (page-1) * count + count);
            this.setState({
                visible_position: array,
                page: page
            })
        }
    }


    searchItems(){
        let filter = '';
        this.props.searchHeader(false);
        if (this.props.user.search_position !== ''){
            filter = this.props.user.search_position;
        }else if(this.props.user.search_items !== ''){
            filter = this.props.user.search_items;
        }
        let array = this.state.catalog.filter(function (item) {return String(item.name).toLowerCase().includes(filter.toLowerCase())});
        this.setState({
            visible_position: array.slice(0, this.state.page_positions),
            filteredList: array,
            page: 1,
            searched: true
        })
    }

    render(){
        const page = Number(this.props.match.params.id);
        const {user} = this.props;
        if(user.search_header) this.searchItems();
        const {cart} = this.props;
        return(
            <main id={'catalog_page'}>
                {page < 1 || this.state.searched? (<Redirect to={'/catalog/1'}/>): undefined}
                <div className={"title_container"}>
                    <p>Каталог</p>
                </div>
                <div>
                    <div className={'catalog_filter'}>
                        <div>
                            <div className={'result_title'}>
                                <p>Фильтр</p>
                            </div>
                            <div className={'result_line'}/>
                        </div>
                        <div className={'catalog_mobile_search'}>
                            <label htmlFor={"search_field"} className={'search'}>
                                <svg className={'search_field_mobile_icon'} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.searchItems}>
                                    <path d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.55055 12.4468 8.05071 12.9999 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z" fill="black" fillOpacity="0.12"/>
                                </svg>
                                <img className={'search_field_desktop_icon'} src={search_icon} alt={'icon'} onClick={() => this.searchItems}/>
                                <input value={this.state.search_name} id={"search_field"} placeholder={'Поиск'}  type={"text"} onKeyDown={this.onKeyPressHandler} onChange={this.filterPositions}/>
                            </label>
                        </div>
                        <div className={'catalog_select_position'}>
                            <button onClick={() => {
                                }}>
                                {Checkboxes(undefined)}
                                <p>Моё оборудование</p>
                            </button>
                            <button onClick={() => {}}>
                                {Checkboxes(undefined)}
                                <p>Мои услуги</p>
                            </button>
                        </div>
                    </div>
                    <div id={'catalog_content'}>
                        <div className={'catalog_desktop_search'}>
                            <label htmlFor={"search_field_desktop"} className={'search'}>
                                <svg className={'search_field_mobile_icon'} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => this.searchItems()}>
                                    <path d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.55055 12.4468 8.05071 12.9999 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z" fill="black" fillOpacity="0.12"/>
                                </svg>
                                <img className={'search_field_desktop_icon'} src={search_icon} alt={'icon'} onClick={() => this.searchItems()}/>
                                <input value={this.state.search_name} id={"search_field_desktop"} placeholder={'Поиск'}  type={"text"} onChange={this.filterPositions} onKeyDown={this.onKeyPressHandler}/>
                            </label>
                            <div className={'catalog_page_positions'}>
                                <p>Показывать по:</p>
                                <div>
                                    <div>
                                        <button onClick={() => this.setCountOfPositions(true)}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="0.318cm" height="0.176cm">
                                                <image  x="0px" y="0px" width="9px" height="5px"  xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAQAAAA9Wg7gAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkCBQRKQD3qC6RAAAAKElEQVQI103JQQoAAAgCwbX//9kOhSgIMsp8jG5M4BpyHUzBo9wAwALwmQoAiXcMnQAAAABJRU5ErkJggg==" />
                                            </svg>
                                        </button>
                                        <button onClick={() => this.setCountOfPositions(false)}>
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                width="0.318cm" height="0.176cm">
                                                <image  x="0px" y="0px" width="9px" height="5px"  xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAQAAAA9Wg7gAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkCBQRKCmsAYe8AAAAJUlEQVQI12P8/58BDTAxMKKJMDIxMKAIMjIwMMEYCJoJiQOVAAC9qwIQy+8mFwAAAABJRU5ErkJggg==" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div>
                                        {this.state.page_positions}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'desktop_catalog_table'}>
                            <div>Название</div>
                            <div>Цена за ед. ₽</div>
                            <div>Услуг в заявке</div>
                        </div>
                        {this.state.loaded_catalog ? (
                            <div>
                                {page > Math.ceil(this.state.filteredList.length/this.state.page_positions)? (<Redirect to={'/catalog/'+Math.ceil(this.state.filteredList.length/this.state.page_positions)}/>): undefined}
                                <div id={"catalog_list"}>
                                    {this.state.visible_position.map((item,index) => (
                                        <CatalogItem index={index} id={item.catalogid} key={item.catalogid} data={item} description={item.customer_name}/>
                                    ))}
                                </div>

                            </div>
                        ): undefined}
                        {this.state.loaded_catalog ? (
                        <div className={"select_page"}>
                            <div className={"select_page_buttons"}>
                                <Link to={"/catalog/" + getPageID(Number(this.props.match.params.id), 1, this.state.filteredList.length, this.state.page_positions)}
                                      onClick={() => this.setPositions(Number(getPageID(Number(this.props.match.params.id), 1, this.state.filteredList.length, this.state.page_positions)), this.state.page_positions)}>
                                    <button className={'select_page_button'}>
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.41 10.58L2.83 6L7.41 1.41L6 0L0 6L6 12L7.41 10.58Z" />
                                        </svg>
                                    </button >
                                </Link>
                                {getPageArray(page, (document.documentElement.clientWidth <1200?1:2), this.state.filteredList.length, this.state.page_positions).map(item => {
                                    if (item === page){
                                        return(
                                            <button id={"now_page"} key={item}>
                                                <div>
                                                    {item}
                                                </div>
                                            </button>
                                        )
                                    }
                                    else
                                        return (
                                            <Link to={"/catalog/"+ item} onClick={() => this.setPositions(item, this.state.page_positions)} key={item}>
                                                <button className={'select_page_button'}>{item}</button>
                                            </Link>
                                        )
                                })}
                                <Link to={"/catalog/" + getPageID(Number(this.props.match.params.id), 2, this.state.filteredList.length, this.state.page_positions) }
                                      onClick={() => this.setPositions(Number(getPageID(Number(this.props.match.params.id), 2, this.state.filteredList.length, this.state.page_positions)), this.state.page_positions)}>
                                    <button className={'select_page_button'}>
                                        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.59 1.42L5.17 6L0.59 10.59L2 12L8 6L2 0L0.59 1.42Z" />
                                        </svg>
                                    </button>
                                </Link>
                            </div>
                        </div>
                        ): undefined}
                    </div>
                </div>
            </main>
        )
    }
}

function getPageID(id, type, limit,count){
    switch (type) {
        case 1:
            if (id <= 1)
                return 1;
            else
                return id - 1;
        case 2:
            if (id >= Math.ceil(limit/count))
                return id;
            else
                return id + 1;
        default:
            return 1;
    }

}

function getPageArray(page, type, limit, count){
    if (type === 1) {
        if (page < Math.ceil(limit/count)) {
            if (page > 1) {
                return [page - 1, page, page + 1]
            } else if (page === 1) {
                return [page, page + 1, page + 2]
            }
        }
        else if(Math.ceil(limit / count) < 3){
            switch (Math.ceil(limit / count)) {
                case 2:
                    return [1,2];
                case 1:
                    return [1];
            }
        }
        else {
            return [page-2, page-1, page]
        }
    }
    else if (type === 2){
        if (Math.ceil(limit / count) > 4) {
            if (page < Math.ceil(limit/count) -1) {
                if (page > 2) {
                    return [page - 2, page - 1, page, page + 1, page + 2];
                } else if (page === 1) {
                    return [page, page + 1, page + 2, page + 3, page + 4];
                } else if (page === 2)
                    return [page - 1, page, page + 1, page + 2, page + 3];
            } else {
                if (page === Math.ceil(limit / count) - 1)
                    return [page - 3, page - 2, page - 1, page, page + 1];
                else
                    return [page - 4, page - 3, page - 2, page - 1, page];
            }
        }else{
            switch (Math.ceil(limit / count)) {
                case 4:
                    return [1,2,3,4];
                case 3:
                    return [1,2,3];
                case 2:
                    return [1,2];
                case 1:
                    return [1];
            }
        }
        return [1];
    }
}

const mapStateToProps = store => {
    return{
        user: store.user,
        catalog: store.catalog,
        cart: store.cart
    }
};

const mapDispatchToProps = dispatch => {
    return{
        setSearchPosition: (position) => dispatch(setSearchPosition(position)),
        setSearchItem: (item) => dispatch(setSearchItem(item)),
        searchHeader: (flag) => dispatch(searchHeader(flag)),
        setVisiblePosition: (index) => dispatch(setVisiblePosition(index))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogPage)

